import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HisBackendService, GenericValue } from 'hisng';

@Injectable()
export class StateService {

    constructor( private backendService: HisBackendService ) { }

    // get states for given entity
    getStates( entity: string ): Observable<GenericValue[]> {
        return this.backendService.getData( `api/v1/fs/res/state/${entity}` );
    }

}
